module.exports = __webpack_public_path__ + "static/media/10.cb2f5582.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/10.png
// module id = 721
// module chunks = 0